import React, {useState, useEffect}from 'react';
import Select from "react-select";
import {findObjInArr} from "@app/utils/CommonFunctions";
import * as mainService from '@app/services/mainService';

const NhanvienListComponent = ({onChange,value,disable,nhomnhanvien_fk,tableName,id_tableName, path_access, required,labelName, name }) => {
    
    const [listNhanvien, setListNhanvien] = useState([]);

    // Định nghĩa màu sắc cho từng nhóm nhân viên - chỉ khi có giá trị
    const getColorByGroup = (nhomnhanvien_fk) => {
        const colorMap = {
            1: '#e3f2fd', // Nhân viên điều phối - Blue
            2: '#f1f8e9', // Nhân viên cad/cam - Light green
            3: '#fff3e0', // Nhân viên cưa đai - Orange
            4: '#fce4ec', // Nhân viên sáp - Pink
            5: '#f3e5f5', // Nhân viên đắp - Purple
            6: '#f5aba6', // Nhân viên mài - Amber
            7: '#e0f2f1', // Nhân viên giao hàng - Teal
            8: '#efebe9', // Nhân viên sườn - Brown
        };
        return colorMap[nhomnhanvien_fk] || '#f5f5f5';
    };

    const getBorderColor = (nhomnhanvien_fk) => {
        const borderColorMap = {
            1: '#2196f3', // Blue
            2: '#4caf50', // Green
            3: '#ff9800', // Orange
            4: '#e91e63', // Pink
            5: '#9c27b0', // Purple
            6: '#f54a40', // Amber
            7: '#009688', // Teal
            8: '#795548', // Brown
        };
        return borderColorMap[nhomnhanvien_fk] || '#ddd';
    };

    // Custom styles - chỉ highlight khi có value
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: value ? getColorByGroup(nhomnhanvien_fk) : 'white',
            borderColor: value
                ? getBorderColor(nhomnhanvien_fk)
                : state.isFocused ? '#2684ff' : '#cccccc',
            borderWidth: value ? '2px' : '1px',
            boxShadow: state.isFocused
                ? value
                    ? `0 0 0 1px ${getBorderColor(nhomnhanvien_fk)}`
                    : '0 0 0 1px #2684ff'
                : 'none',
            '&:hover': {
                borderColor: value ? getBorderColor(nhomnhanvien_fk) : '#b3b3b3',
            }
        }),

        singleValue: (provided) => ({
            ...provided,
            color: value ? getBorderColor(nhomnhanvien_fk) : '#333',
            fontWeight: value ? '600' : '400'
        }),

        placeholder: (provided) => ({
            ...provided,
            color: '#999'
        })
    };

      useEffect(async () => {
            
            const cqtemp = await mainService.getAllNhanvien({ path_access:path_access, nhomnhanvien_fk: nhomnhanvien_fk, tableName: tableName,id_tableName: id_tableName });
            setListNhanvien(cqtemp);

        }, [nhomnhanvien_fk]);

    return  <>
                                        <label className={ required? required : "" } style={{
                                            color: value ? getBorderColor(nhomnhanvien_fk) : '#333',
                                            fontWeight: value ? '600' : '400'
                                        }} >
                                            {labelName ? labelName: "Nhân viên"}
                                        </label>
                                        <Select
                                            isClearable
                                            isSearchable={false}
                                            name={name ? name: "nhanvien_fk"}
                                            onChange={onChange}
                                            value={findObjInArr(listNhanvien, value)}
                                            options={listNhanvien}
                                            isDisabled={disable}
                                            styles={customStyles}
                                            placeholder={`Chọn ${labelName || 'nhân viên'}...`}
                                        />
                                       
                                    </>
};

export default NhanvienListComponent;
